var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatChattingFilled = function SvgChatChattingFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2563EB",
    d: "M14.667 7.333A6 6 0 0 0 2.966 5.458a5.6 5.6 0 0 1 7.507 7.704 27.368 27.368 0 0 1 .278-.03l.022-.003h.007l.086-.006h.03l.087.001c.071.001.143.006.336.02l1.185.084c.233.017.448.032.628.03.193-.003.413-.026.633-.13.305-.145.552-.39.696-.697.104-.219.127-.44.13-.632.003-.18-.013-.395-.03-.628l-.084-1.185a6.173 6.173 0 0 1-.02-.337l-.001-.085v-.031l.006-.086V9.44l.003-.022.008-.08.03-.273.12-1.008.001-.006c.028-.236.043-.475.043-.718Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2563EB",
    d: "M5.6 6.134A4.254 4.254 0 0 0 2.765 7.21a4.258 4.258 0 0 0-1.379 3.865 106.729 106.729 0 0 1 .096.615l.002.028.002.022v.055c0 .032-.003.078-.014.239l-.068.945c-.01.153-.022.306-.02.437.002.144.019.329.108.517.12.252.322.454.574.574.188.089.373.106.517.108.13.002.284-.01.437-.02l.946-.068c.16-.011.206-.014.239-.014H4.259l.05.004.039.006.122.018.454.072a4.258 4.258 0 0 0 3.865-1.38A4.267 4.267 0 0 0 5.6 6.134Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatChattingFilled);
export default ForwardRef;